import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { 
    StarryBackground, 
    NebulaEffect, 
    ContentContainer, 
    HeaderContainer, 
    TitleContainer, 
    BackButton, 
    IframeContainer 
} from './styled';

const rmiacURL = process.env.REACT_APP_RMIAC as string;

const Monitoring: FC = () => {
    const navigate = useNavigate();

    return (
        <StarryBackground>
            <NebulaEffect />
            <ContentContainer>
                <HeaderContainer>
                    <BackButton 
                        onClick={() => navigate('/')}
                        startIcon={<ArrowBackIcon />}
                    >
                        Назад
                    </BackButton>

                    <TitleContainer>
                        <Typography 
                            color='white' 
                            variant='h1' 
                            sx={{
                                fontSize: '48px',
                                fontWeight: 'bold',
                                textShadow: `
                                    0 0 10px rgba(59, 130, 246, 0.5),
                                    0 0 20px rgba(59, 130, 246, 0.3),
                                    0 0 30px rgba(59, 130, 246, 0.2)
                                `,
                                animation: 'titleGlow 3s ease-in-out infinite',
                                '@keyframes titleGlow': {
                                    '0%, 100%': {
                                        textShadow: `
                                            0 0 10px rgba(59, 130, 246, 0.5),
                                            0 0 20px rgba(59, 130, 246, 0.3),
                                            0 0 30px rgba(59, 130, 246, 0.2)
                                        `,
                                    },
                                    '50%': {
                                        textShadow: `
                                            0 0 15px rgba(59, 130, 246, 0.8),
                                            0 0 25px rgba(59, 130, 246, 0.5),
                                            0 0 35px rgba(59, 130, 246, 0.3)
                                        `,
                                    },
                                },
                            }}
                        >
                            К
                            <IconButton 
                                href={rmiacURL}
                                target='_blank'
                                sx={{ 
                                    padding: 0,
                                    marginBottom: '10px',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        backgroundColor: 'transparent',
                                        transform: 'scale(1.1)',
                                        cursor: 'pointer',
                                    }
                                }}
                            >
                                <img src='/logo-cosmos.svg' alt='custom icon' style={{ width: 50, height: 50 }} />
                            </IconButton>
                            СМОС
                        </Typography>
                    </TitleContainer>
                    <Typography 
                        color='white' 
                        variant='h3' 
                        sx={{
                            fontSize: '24px',
                            fontWeight: 'normal',
                            textAlign: 'center',
                            marginTop: '10px',
                            textShadow: `
                                0 0 5px rgba(59, 130, 246, 0.3),
                                0 0 10px rgba(59, 130, 246, 0.2)
                            `,
                        }}
                    >
                        Мониторинг
                    </Typography>
                    <Box width="100px" /> {/* Spacer для балансировки */}
                </HeaderContainer>

                <IframeContainer>
                    <iframe
                        src="/monitoring/index.html"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        style={{
                            border: 'none',
                            borderRadius: '12px',
                        }}
                        title="Мониторинг"
                        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals"
                    />
                </IframeContainer>
            </ContentContainer>
        </StarryBackground>
    );
};

export default Monitoring;
